"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarPane = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ContextMenu_1 = require("../ContextMenu");
const nano_theme_1 = require("nano-theme");
const flexClass = (0, nano_theme_1.rule)({
    d: 'flex',
    fld: 'row',
    ai: 'center',
    pd: '4px',
    h: '32px',
});
const ToolbarPane = ({ children, ...rest }) => {
    let style = rest.style;
    if (rest.compact) {
        style = { padding: 2 };
    }
    return (React.createElement(ContextMenu_1.ContextPane, { ...rest },
        React.createElement("div", { className: flexClass, style: style }, children)));
};
exports.ToolbarPane = ToolbarPane;
